export default __webpack_public_path__ + "static/media/pilgrim.2a2f533b.png";